import { render } from "./Memento.vue?vue&type=template&id=27f652f0&scoped=true&ts=true"
import script from "./Memento.ts?vue&type=script&lang=ts"
export * from "./Memento.ts?vue&type=script&lang=ts"

import "./Memento.scss?vue&type=style&index=0&id=27f652f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f652f0"]])

export default __exports__